import { ShieldCheck, ClipboardList, Filter, Zap, Coins, Gift } from "lucide-react";

export const OP_TYPES = [
  {
    key: "surebet",
    label: "Surebet",
    short: "Surebet",
    description: "Aposta segura entre casas com odds cruzadas",
    Icon: ShieldCheck,
    color: "#22C55E",
  },
  {
    key: "proc_freebet",
    label: "Procedimento Freebet",
    short: "Proc. Freebet",
    description: "Freebet Garantida ou Lucro Garantido com defesas",
    Icon: ClipboardList,
    color: "#A1A1AA",
  },
  {
    key: "extracao_freebet",
    label: "Extração Freebet",
    short: "Extração",
    description: "Principal usa freebet, defesas cobrem o hedge",
    Icon: Filter,
    color: "#F97316",
  },
  {
    key: "aumentada",
    label: "Aumentada",
    short: "Aumentada",
    description: "Odd aumentada / promoção com boost",
    Icon: Zap,
    color: "#3B82F6",
  },
  {
    key: "giros",
    label: "Giros",
    short: "Giros",
    description: "Giros grátis / prêmios promocionais — só casa + valor ganho",
    Icon: Coins,
    color: "#EC4899",
  },
];

export const LEGACY_FREEBET = {
  key: "freebet",
  label: "Freebet",
  short: "Freebet",
  description: "Freebet (legado)",
  Icon: Gift,
  color: "#EAB308",
};

export const OP_TYPE_MAP = Object.fromEntries([...OP_TYPES, LEGACY_FREEBET].map((t) => [t.key, t]));

export function opMeta(key) {
  return OP_TYPE_MAP[key] || OP_TYPES[0];
}
